export const OPERATIONS_API_ROUTE = '/api/monitoring';

export const buildGetProjectStatusUrl = (projectCode) => `${OPERATIONS_API_ROUTE}/${projectCode}/status`;

export const buildGetDataSourceStatusUrl = (projectCode, dataSourceCode) => `${OPERATIONS_API_ROUTE}/${projectCode}/datasources/${dataSourceCode}/status`;

const DATALAKE_API_ROUTE = '/api/datalake';

export const buildGetOperationDetails = (operationId) => `${DATALAKE_API_ROUTE}/${operationId}`;

export const buildGetProviderUrls = (operationId) => `${DATALAKE_API_ROUTE}/${operationId}/provider-urls`;
